// extracted by mini-css-extract-plugin
module.exports = {"container":"h1","optionsWrap":"h2","option":"h3","optionActive":"h4"};